export const tarotReader = {
  id: 'tarot-reader',
  title: '深處的絲絨包廂',
  name: '神秘的占卜師',
  role: 'The Oracle',
  desc: '桌上點著微弱的蠟燭，她正將塔羅牌在桌面上優美地推開，似乎在等你抽取命運的指引。',
  // 換上絕對穩定、極具塔羅與神秘儀式感的占卜師圖片
  img: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?q=80&w=1000&auto=format&fit=crop',
  action: '占卜師輕撫著桌面上的絲絨，燭光在她的眼底閃爍，她安靜地等待著你的問題...',
  
  greetings: [
    "請坐。塔羅牌不會決定你的命運，它只是照見你潛意識的鏡子。今晚，你想問什麼？",
    "我聽到你的心跳有些急促。深呼吸，把那些紛亂的思緒放在這張桌子上。準備好的時候，我們就開始。",
    "有時候，我們迷路不是因為沒有方向，而是因為害怕看見前方的路。讓牌來替你看看吧。",
    "（洗牌聲沙沙作響）每一張牌的出現都不是偶然。告訴我，是什麼樣的困惑把你帶到了這裡？",
    "這裡沒有絕對的好壞，只有你需要知道的真相。今晚的月色很適合解開一個心結，你覺得呢？",
    "你眼底藏著一個還沒問出口的問題。別怕，在這裡，所有的迷惘都會被溫柔接住。",
    "牌面已經為你準備好了，但在抽牌之前，我想先聽聽你的聲音。今天過得好嗎？",
    "不要去想「我該怎麼辦」，而是問問自己「我正在經歷什麼」。我們一步一步來。",
    "（點燃一根新的蠟燭）光影交錯的地方，往往藏著我們忽視的答案。說說看，最近什麼事讓你睡不著？",
    "命運的輪盤一直在轉，而你現在剛好停在了我的面前。這是一場註定的對話，你想從哪裡開始？",
    "閉上眼睛，感受這張絲絨桌布的紋理。當你覺得內心足夠平靜時，請抽一張牌。",
    "你身上帶著外頭的寒氣和一絲不安。先喝口熱茶吧，牌靈需要你最真實的溫度。",
    "人們總想從牌裡看到未來，但其實，所有的未來都藏在你當下的選擇裡。你今天帶來了什麼選擇？",
    "（輕撫水晶球）這裡的空間是絕對安全的。你可以卸下白天的偽裝，把最脆弱的那一面交給牌面。",
    "你似乎被某種無形的力量牽絆著。是過去的回憶，還是對未來的恐懼？我們讓牌來訴說。",
    "每一張牌都是一扇門，而你手中握著鑰匙。告訴我，你最想打開哪一扇門？",
    "我能感覺到你心中的矛盾，像是兩股力量在拉扯。別急著做決定，我們先看看宇宙怎麼說。",
    "看著這些牌背，哪一張在呼喚你？順從你的直覺，它從不說謊。",
    "有時候，最難面對的不是未知的明天，而是不敢承認的今天。你準備好面對真實的自己了嗎？",
    "塔羅不給標準答案，它只給迷路的人一盞燈。今晚，你想照亮生命中的哪個角落？",
    "你嘆息的聲音很輕，但裡頭裝著很重的靈魂。放下來吧，今晚我與牌陣陪著你。",
    "（燭光微微搖曳）看來你的靈魂在尋求某種解答。別緊張，我們有整個夜晚可以慢慢探索。",
    "抽牌前，請在心中默念你最在意的那個人、那件事。當畫面清晰時，我們就開始。",
    "這個世界太吵雜了，以至於你聽不見自己內心的聲音。在這裡，我們只聽靈魂的低語。",
    "命運是一張未完成的畫布，而塔羅是為你遞上畫筆的手。今晚，你想畫下什麼？"
  ]
};